import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { SetField } from '../components/Table/fields/SetField';
import { activity } from './activity';
import { CompetitorPrice } from '../types/entities/CompetitorPrice';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { competitor } from './competitor';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";

export const competitorPrice: SchemaWithClient<CompetitorPrice> = {
  name: 'Competitor Price',
  pluralName: 'Competitor Price',
  columns: {
    activity: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(activity),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(activity),
      switchboard: true,
      url: activity.client.getAllPath,
      tempSchema: activity,
    },
    description: {
      name: 'Description',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    competitor: {
      name: 'Competitor',
      fieldRenderer: SelectField.tableAdapter(competitor),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(competitor),
      switchboard: true,
      url: competitor.client.getAllPath,
      tempSchema: competitor,
    },
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    price: {
      name: 'Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'medium',
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      width: 'medium',
    },
    updated_date: {
      name: 'Updated Date',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    sales_partners: {
      name: 'Sales Partners',
      fieldRenderer: SetField.tableAdapter(enumItems.salesPartner),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.salesPartner),
      multiSwitchboard: true,
      url: enumItems.salesPartner.client.getAllPath,
      tempSchema: enumItems.salesPartner,
    },
    notes: {
      name: 'Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },

    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/competitor-prices'),
};
